import { NgModule } from '@angular/core';
import { HouseholdAddComponent } from './household-add/household-add.component';
import { MemberSearchModule } from 'src/app/shared/member-search/member-search.module';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { CommonModule } from '@angular/common';
import { ButtonsModule, ButtonGroupModule, ButtonModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';

@NgModule({
  imports: [
    MemberSearchModule,
    DialogsModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    CommonModule,
    ButtonModule,
    DropDownButtonModule,
    ButtonsModule,
    ButtonGroupModule
  ],
  declarations: [
    HouseholdAddComponent
  ],
  exports: [
    HouseholdAddComponent
  ],
})
export class HouseholdModule { }
